(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[34260],{

/***/ 76798:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CheckIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function CheckIcon({ className , fill  }) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        x: "0",
        y: "0",
        enableBackground: "new 0 0 32 26",
        version: "1.1",
        viewBox: "0 0 32 26",
        xmlSpace: "preserve",
        className: className ?? "",
        fill: fill,
        style: {
            fill: fill
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M27.1 0L25 2.2 10.7 17.4l-4.3-4.3L4.2 11 0 15.2l2.1 2.1 6.5 6.5 2.2 2.2 2.1-2.2L29.4 6.3l2.1-2.2L27.1 0z"
        })
    });
}


/***/ }),

/***/ 51132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DoubleArrowIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function DoubleArrowIcon({ className  }) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "21",
        height: "18",
        viewBox: "0 0 21 18",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            fill: "none",
            fillRule: "evenodd",
            stroke: "none",
            strokeWidth: "1",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                fill: "#FFF",
                fillRule: "nonzero",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M2.51945229 0L-4.23661106e-13 2.48571429 6.66011737 9 -4.23661106e-13 15.5142857 2.51945229 18 11.7209302 9z"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M11.7985221 0L9.27906977 2.48571429 15.9391871 9 9.27906977 15.5142857 11.7985221 18 21 9z"
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 34260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ mainListing; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/lib/shared/config.ts
var config = __webpack_require__(98218);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/svg/checkIcon.tsx
var checkIcon = __webpack_require__(76798);
// EXTERNAL MODULE: ./src/components/websitebuilderselect/offer/offer.module.scss
var offer_module = __webpack_require__(7778);
var offer_module_default = /*#__PURE__*/__webpack_require__.n(offer_module);
// EXTERNAL MODULE: ./src/components/svg/doubleArrowIcon.tsx
var doubleArrowIcon = __webpack_require__(51132);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/shared/affiliateOfferUrl/index.tsx + 1 modules
var affiliateOfferUrl = __webpack_require__(25416);
;// CONCATENATED MODULE: ./src/components/websitebuilderselect/offer/index.tsx







const Offer = ({ id , offer , comparison , zone  })=>{
    const { logo , features , attributes , price , currency ="$"  } = offer;
    const wantedAttributes = [
        "free plan",
        "storage space",
        "free domain",
        "ecommerce plan", 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: `flex relative p-3 border-b-2 lg:border-2 flex-col justify-between lg:my-6 lg:h-72 ${(offer_module_default())["listing-item"]} ${comparison ? (offer_module_default()).shift : ""}`,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(affiliateOfferUrl/* default */.Z, {
                zone: zone,
                offer: offer,
                target: "_blank",
                className: "absolute w-full h-full top-0 left-0 z-10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: `flex absolute top-3 left-3 w-8 h-8 lg:w-12 lg:h-12 rounded ${(offer_module_default()).gray} items-center font-bold text-base lg:text-2xl justify-center`,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: id + 1
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: `flex flex-row justify-between items-center h-full lg:mb-5`,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "ml-4 xs:ml-10 sm:ml-16 md:w-28 lg:ml-32",
                        children: logo?.fullPath && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: `${logo.fullPath}`,
                            width: 120,
                            height: 120,
                            alt: offer.title
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "hidden lg:block w-5/12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "flex h-24 flex-wrap text-sm content-center",
                            children: features?.map((item, idx)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    className: "flex items-center mb-2 w-6/12 h-3.5",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(checkIcon/* default */.Z, {
                                            className: "w-3 h-3 mr-2"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: item
                                        })
                                    ]
                                }, idx);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-center flex-col text-base ml-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center justify-start mr-1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: ` ml-2 font-bold lg:text-2xl`,
                                    children: [
                                        currency,
                                        price,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-xs font-light",
                                            children: "/month"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                className: `${(offer_module_default()).button} h-10 flex items-center justify-center lg:text-xl py-2 w-32 lg:w-40 rounded-md font-bold`,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "Visit Site"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(doubleArrowIcon/* default */.Z, {
                                        className: "w-3 md:w-4 ml-2 lg:w-5"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            Object.keys(attributes).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: `text-sm mt-3 lg:mt-0 hidden lg:flex`,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: `${(offer_module_default()).yellow} justify-evenly md:justify-around text-xs p-3 flex rounded-md w-full font-poppins`,
                    children: Object.keys(attributes).map((attributeKey, idx)=>{
                        return wantedAttributes.includes(attributeKey?.toLocaleLowerCase()) && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-row",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        attributeKey,
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "font-bold",
                                            children: attributes[attributeKey]?.toLowerCase()?.includes("true") ? "Available" : attributes[attributeKey]
                                        })
                                    ]
                                })
                            })
                        }, idx);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var offer = (Offer);

// EXTERNAL MODULE: ./src/components/websitebuilderselect/mainListing/mainListing.module.scss
var mainListing_module = __webpack_require__(26011);
var mainListing_module_default = /*#__PURE__*/__webpack_require__.n(mainListing_module);
;// CONCATENATED MODULE: ./src/components/websitebuilderselect/mainListing/index.tsx





const MainListing = ({ listing , comparison  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: ` pb-10 lg:pt-10 ${(mainListing_module_default()).listing} ${comparison ? (mainListing_module_default()).comparison : ""}`,
        children: listing && listing.map((item, idx)=>{
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(offer, {
                zone: config/* affiliateOfferZones */.ZR[comparison ? "COMPARISON_PAGE" : "HOME_PAGE"],
                id: idx,
                offer: item,
                comparison: comparison
            }, idx);
        })
    });
};
/* harmony default export */ var mainListing = (MainListing);


/***/ }),

/***/ 26011:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"listing":"mainListing_listing__N5k1e"};

/***/ }),

/***/ 7778:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"offer_gray__6Ge1E","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"offer_yellow__CHlbg","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"offer_button__dOKTu","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","listing-item":"offer_listing-item__yhJUx","shift":"offer_shift__5h2Yf"};

/***/ })

}]);